<template>
  <v-app-bar
      app
      dark
  >
    <router-link to="/" style="text-decoration: none">
      <div class="d-flex align-center">
        <v-img
            alt="QSY"
            class="shrink mr-2"
            contain
            :src="require('@/assets/logo.png')"
            transition="scale-transition"
            width="50"
        />
        Quantium Singularity
      </div>
    </router-link>
    <v-spacer></v-spacer>

    <v-tabs align-with-title v-if="!isMobile">
      <v-tab to="/">Home</v-tab>
      <v-tab to="/skill-plans">Skill Plans</v-tab>
      <v-tab to="/fittings">Fittings</v-tab>
      <v-tab to="/links">Links</v-tab>
      <v-tab to="/photos">Photos</v-tab>
      <v-tab to="/about">About Us</v-tab>
    </v-tabs>

    <v-menu v-else>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item to="/">
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item>
        <v-list-item to="/skill-plans">
          <v-list-item-title>Skill Plans</v-list-item-title>
        </v-list-item>
        <v-list-item to="/fittings">
          <v-list-item-title>Fittings</v-list-item-title>
        </v-list-item>
        <v-list-item to="/links">
          <v-list-item-title>Links</v-list-item-title>
        </v-list-item>
        <v-list-item to="/photos">
          <v-list-item-title>Photos</v-list-item-title>
        </v-list-item>
        <v-list-item to="/about">
          <v-list-item-title>About</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>
<script>

    export default {

        data: () => ({})
        ,
        methods: {},
        computed: {
            isMobile() {
                return this.$vuetify.breakpoint.smAndDown;
            }
        },
    }
</script>
<style scoped lang="scss">
</style>
